import React from 'react'
import lang from '../services/lang'

export const Welcome = () =>
  <div className="jumbotron">
    <h1 className="display-4">{lang.welcome_title}</h1>
    <p className="lead">{lang.welcome_text1}</p>
    <hr className="my-4"/>
    <p>{lang.welcome_text2}</p>
  </div>;